import '@/common';
import { createCatalogToolbarWidget } from '@/widgets/CatalogToolbarWidget';
import {JSONParser} from "@/utils/JSONParser";
import { createQuickPickWidget } from '@/widgets/QuickPickWidget';
import { createCatalogWidget } from '@/widgets/CatalogWidget';
import {createOpenFeedbackWidget} from "@/widgets/OpenFeedbackWidget";
import * as widgets from "@/common/widgets";

createQuickPickWidget(document.querySelector('#quick-pick-widget')!);
createCatalogWidget(document.querySelector('#catalog-widget')!);

const parser = new JSONParser('main-page');

window.addEventListener('load', () => {

    [...document.querySelectorAll('.toolbar-widget')].forEach((el) => {
        createCatalogToolbarWidget(el!);
    });

    const timeTimes = document.querySelector<HTMLElement>('.product-baners-time ._time-times');

    if(timeTimes) {
        const parserTimeTimes = new JSONParser('time-times');
        let diffInMS = Number(timeTimes.getAttribute('data-diff-msec'));
        diffInMS = diffInMS+1000;

        setInterval(() => {

            diffInMS = diffInMS-1000;
            const diffAsDate = new Date(diffInMS);

            const [
                years,
                months,
                days,
                hours,
                minutes,
                seconds
            ] = diffAsDate
                .toISOString()
                .split('T')
                .map(timePart =>
                    timePart
                        .split(/-|:|\./)
                        .map(str => +str)
                )
                .flat();

            const counterD = timeTimes.querySelector('._counter-d');
            if(counterD){
                counterD.textContent=`${ (days < 10) ? "0"+days : days }`;
            }
            const counterCh = timeTimes.querySelector('._counter-ch');
            if(counterCh){
                counterCh.textContent=`${ (hours < 10) ? "0"+hours : hours }`;
            }
            const counterM = timeTimes.querySelector('._counter-m');
            if(counterM){
                counterM.textContent=`${ (minutes < 10) ? "0"+minutes : minutes }`;
            }
            const counterS = timeTimes.querySelector('._counter-s');
            if(counterS){
                counterS.textContent=`${ (seconds < 10) ? "0"+seconds : seconds }`;
            }
            //timeLeft.textContent = `${years - 1970} лет ___ ${months - 1} месяца ___ ${days - 1} дней ___ ${hours} час ___ ${minutes} минут ___ ${seconds} секунд`;

        }, 1000);

    }

});
